
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img
              src="https://static.readdy.ai/image/e468a762cbf2c4de3f207872d8ecdaa7/249121c6a7dc8fcc1d538c9d07722d0f.png"
              alt="VE Goodies"
              className="h-12 w-auto mb-6"
            />
            <p className="text-sm text-gray-400 leading-relaxed mb-6">
              Providing premium healthy vending machine solutions across the Dallas-Fort Worth metroplex.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-orange-500 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-orange-500 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-full hover:bg-orange-500 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-sm text-gray-400 hover:text-orange-400 transition-colors cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-gray-400 hover:text-orange-400 transition-colors cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('testimonials')}
                  className="text-sm text-gray-400 hover:text-orange-400 transition-colors cursor-pointer"
                >
                  Testimonials
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('locations')}
                  className="text-sm text-gray-400 hover:text-orange-400 transition-colors cursor-pointer"
                >
                  Locations
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-sm text-gray-400 hover:text-orange-400 transition-colors cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-sm text-gray-400 hover:text-orange-400 transition-colors cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Services</h3>
            <ul className="space-y-3">
              <li className="text-sm text-gray-400">Machine Placement</li>
              <li className="text-sm text-gray-400">Product Stocking</li>
              <li className="text-sm text-gray-400">24/7 Maintenance</li>
              <li className="text-sm text-gray-400">Healthy Options</li>
              <li className="text-sm text-gray-400">Custom Branding</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-orange-400"></i>
                </div>
                <a href="tel:+14699223413" className="text-sm text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                  (469) 922-3413
                </a>
              </li>
              <li className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-orange-400"></i>
                </div>
                <a href="mailto:vegoodiesllc@gmail.com" className="text-sm text-gray-400 hover:text-orange-400 transition-colors cursor-pointer">
                  vegoodiesllc@gmail.com
                </a>
              </li>
              <li className="flex items-start">
                <div className="w-5 h-5 flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-orange-400"></i>
                </div>
                <span className="text-sm text-gray-400">
                  Little Elm, Frisco, Carrollton<br />Dallas-Fort Worth, TX
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="text-sm text-gray-400 mb-4 md:mb-0">
              © 2025 VE Goodies. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <a
                href="/terms"
                className="text-sm text-gray-400 hover:text-orange-400 transition-colors cursor-pointer"
              >
                Terms & Conditions
              </a>
              <a
                href="/privacy"
                className="text-sm text-gray-400 hover:text-orange-400 transition-colors cursor-pointer"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
